import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Chip,
  useTheme,
  Paper,
} from "@mui/material";

const formControlStyles = {
  minWidth: 160,
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#d91a5f",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#d91a5f",
      boxShadow: "0 0 0 1px rgba(217, 26, 95, 0.15)",
    },
  },
};

const inputLabelStyles = {
  color: "#757575",
  "&.Mui-focused": {
    color: "#d91a5f",
  },
};

const StatusBlock = ({
  details,
  status,
  scribingStatus,
  codestatus,
  onOverallChange,
  onScribingChange,
  onCodingChange,
}) => {
  const theme = useTheme();

  const getStatusColor = (value) => {
    if (value === "Completed") return "success";
    if (value === "In-Progress" || value === "In-Coding") return "warning";
    if (value === "On-Hold") return "error";
    return "default";
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: theme.palette.grey[200],
        mb: 2,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography fontSize={15} fontWeight={600} color="text.primary">
          Status
        </Typography>
        <Chip
          size="small"
          label={status || "Not Started"}
          color={getStatusColor(status)}
          variant={status ? "filled" : "outlined"}
        />
      </Box>

      <Box display="flex" flexWrap="wrap" gap={2} mb={2} mt={0.5}>
        <FormControl variant="outlined" size="small" sx={formControlStyles}>
          <InputLabel sx={inputLabelStyles}>Scribing</InputLabel>
          <Select
            value={scribingStatus}
            label="Scribing"
            onChange={onScribingChange}
          >
            <MenuItem value="Not Started">Not Started</MenuItem>
            <MenuItem value="In-Progress">In-Progress</MenuItem>
            <MenuItem value="Completed">Completed</MenuItem>
          </Select>
        </FormControl>

        <FormControl variant="outlined" size="small" sx={formControlStyles}>
          <InputLabel sx={inputLabelStyles}>Coding Review</InputLabel>
          <Select
            value={codestatus}
            label="Coding Review"
            onChange={onCodingChange}
          >
            <MenuItem value="Not Started">Not Started</MenuItem>
            <MenuItem value="In-Progress">In-Progress</MenuItem>
            <MenuItem value="Completed">Completed</MenuItem>
          </Select>
        </FormControl>

        <FormControl variant="outlined" size="small" sx={formControlStyles}>
          <InputLabel sx={inputLabelStyles}>Overall</InputLabel>
          <Select value={status} label="Overall" onChange={onOverallChange}>
            <MenuItem value="In-Progress">In-Progress</MenuItem>
            <MenuItem value="In-Transcription">In-Transcription</MenuItem>
            <MenuItem value="In-Scribing">In-Scribing</MenuItem>
            <MenuItem value="Coding">In-Coding</MenuItem>
            <MenuItem value="Pending AI Coding">Pending AI Coding</MenuItem>
            <MenuItem value="On-Hold">On-Hold</MenuItem>
            <MenuItem value="Completed">Completed</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box
        display="flex"
        flexWrap="wrap"
        gap={3}
        sx={{
          p: 1.5,
          borderRadius: 2,
          backgroundColor: "#fff",
          border: "1px dashed",
          borderColor: theme.palette.grey[300],
        }}
      >
        <Box minWidth={160}>
          <Typography fontSize={11} fontWeight={600} color="text.secondary">
            Scribing By
          </Typography>
          <Typography fontSize={12} color="text.primary">
            {details.scribing_by || "-"}
          </Typography>
        </Box>

        <Box minWidth={160}>
          <Typography fontSize={11} fontWeight={600} color="text.secondary">
            Scribing Date
          </Typography>
          <Typography fontSize={12} color="text.primary">
            {details.scribing_date || "-"}
          </Typography>
        </Box>

        <Box minWidth={160}>
          <Typography fontSize={11} fontWeight={600} color="text.secondary">
            Coding Review By
          </Typography>
          <Typography fontSize={12} color="text.primary">
            {details.coding_review_by || "-"}
          </Typography>
        </Box>

        <Box minWidth={160}>
          <Typography fontSize={11} fontWeight={600} color="text.secondary">
            Coding Review Date
          </Typography>
          <Typography fontSize={12} color="text.primary">
            {details.coding_review_date || "-"}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default StatusBlock;
